import { LoadingButton } from "@mui/lab";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  calculateBrandedColor,
  calculateKeywordsColor,
  calculateLinkRatio,
} from "../../../pages/postEditor/seoAnalyzer/linkingHelper";
import { setCompetitorAnalysis } from "../../../redux/slices/competitorSlice";

import { dispatch } from "../../../redux/store";
import { useGetLinkTableByPageIdMutation } from "../../../redux/slices/postEditorBlogSlice";
export default function LinkCard({ analysis, content, index }) {
  const competitorResults = useSelector(
    (state) => state.competitorAnalysis.data?.data
  );
  const [loadPageLinkTable, { isLoading: loadingPageLinkTable }] =
    useGetLinkTableByPageIdMutation();
  const { t } = useTranslation();

  // Calulate Interal/External Link Ratio
  const ratioScore = useMemo(() => {
    return analysis?.linking
      ? calculateLinkRatio(
          analysis?.linking?.nb_internal_links,
          analysis?.linking?.nb_external_links
        )
      : 0;
  }, [analysis]);

  // Linking Table Button for opening
  const handleLinkingTableByPageId = async () => {
    const res = await loadPageLinkTable({
      seo_analysis_id: competitorResults?.id,
      page_id: index + 1,
    });
    if (res?.data) {
      dispatch(
        setCompetitorAnalysis({
          data: {
            ...competitorResults,
            pageLinks: {
              table: res?.data,
              id: index,
            },
          },
        })
      );
    }
  };

  // Linking Table Button for closing
  const handleHidePageLinkTable = () => {
    dispatch(
      setCompetitorAnalysis({
        data: {
          ...competitorResults,
          pageLinks: null,
        },
      })
    );
  };

  return analysis !== undefined && content !== undefined ? (
    <>
      <div className="py-3">
        <div className="break-words">
          {/* Internal/External Link Ratio */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t(
                "Internal/external_link_ratio",
                "Internal/external link ratio"
              )}
              ?
              <span
                className={`${
                  (ratioScore == 100 &&
                    analysis?.linking?.nb_internal_links > 0) ||
                  analysis?.linking?.nb_external_links > 0
                    ? "text-green-500"
                    : (ratioScore == 50 &&
                        analysis?.linking?.nb_internal_links > 0) ||
                      analysis?.linking?.nb_external_links > 0
                    ? "text-yellow-500"
                    : analysis?.linking?.nb_internal_links > 0 ||
                      analysis?.linking?.nb_external_links > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {" "}
                {(ratioScore == 100 &&
                  analysis?.linking?.nb_internal_links > 0) ||
                analysis?.linking?.nb_external_links > 0
                  ? t("Good", "Good")
                  : (ratioScore == 50 &&
                      analysis?.linking?.nb_internal_links > 0) ||
                    analysis?.linking?.nb_external_links > 0
                  ? t("Ok", "Ok")
                  : analysis?.linking?.nb_internal_links > 0 ||
                    analysis?.linking?.nb_external_links > 0
                  ? t("Bad", "Bad")
                  : t("No_link_found", "No link found")}{" "}
                {`${
                  analysis?.linking?.nb_internal_links > 0 ||
                  analysis?.linking?.nb_external_links > 0
                    ? `   (${analysis?.linking?.nb_internal_links}:
                                ${analysis?.linking?.nb_external_links})`
                    : ""
                }`}
              </span>
            </span>
          </div>

          {/* Link Distribution  */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t("Link_distribution_in_text", "Link distribution in text")}?
              <span
                className={`${
                  analysis?.linking?.link_distribution == 2 &&
                  (analysis?.linking?.nb_internal_links > 0 ||
                    analysis?.linking?.nb_external_links > 0)
                    ? "text-green-500"
                    : analysis?.linking?.link_distribution == 1 &&
                      (analysis?.linking?.nb_internal_links > 0 ||
                        analysis?.linking?.nb_external_links > 0)
                    ? "text-yellow-500"
                    : analysis?.linking?.nb_internal_links > 0 ||
                      analysis?.linking?.nb_external_links > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {" "}
                {analysis?.linking?.link_distribution == 2 &&
                (analysis?.linking?.nb_internal_links > 0 ||
                  analysis?.linking?.nb_external_links > 0)
                  ? t("Good", "Good")
                  : analysis?.linking?.link_distribution == 1 &&
                    (analysis?.linking?.nb_internal_links > 0 ||
                      analysis?.linking?.nb_external_links > 0)
                  ? t("Ok", "Ok")
                  : analysis?.linking?.nb_internal_links > 0 ||
                    analysis?.linking?.nb_external_links > 0
                  ? t("Bad", "Bad")
                  : t("No_link_found", "No link found")}
              </span>
            </span>
          </div>

          {/* Anchor Type Score */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t("Anchor_text_type_score", "Anchor text type score")}?
              <span
                className={`${
                  analysis?.linking?.anchor_text_type_score >= 75 &&
                  (analysis?.linking?.nb_internal_links > 0 ||
                    analysis?.linking?.nb_external_links > 0)
                    ? "text-green-500"
                    : analysis?.linking?.anchor_text_type_score < 75 &&
                      analysis?.linking?.anchor_text_type_score > 35 &&
                      (analysis?.linking?.nb_internal_links > 0 ||
                        analysis?.linking?.nb_external_links > 0)
                    ? "text-yellow-500"
                    : analysis?.linking?.nb_internal_links > 0 ||
                      analysis?.linking?.nb_external_links > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {" "}
                {analysis?.linking?.anchor_text_type_score &&
                (analysis?.linking?.nb_internal_links > 0 ||
                  analysis?.linking?.nb_external_links > 0)
                  ? t("Good", "Good")
                  : analysis?.linking?.anchor_text_type_score == 50 &&
                    (analysis?.linking?.nb_internal_links > 0 ||
                      analysis?.linking?.nb_external_links > 0)
                  ? t("Ok", "Ok")
                  : analysis?.linking?.nb_internal_links > 0 ||
                    analysis?.linking?.nb_external_links > 0
                  ? t("Bad", "Bad")
                  : t("No_link_found", "No link found")}
              </span>
              {(analysis?.linking?.nb_internal_links > 0 ||
                analysis?.linking?.nb_external_links > 0) && (
                <ul className="ps-3 list-disc list-inside">
                  <li
                    className={`${calculateKeywordsColor(
                      analysis?.linking?.anchor_text_type_ratios?.branded,
                      analysis?.linking?.anchor_text_type_ratios?.keywords
                    )}`}
                  >
                    {t("Keywords", "Keywords")} :{" "}
                    {analysis?.linking?.anchor_text_type_ratios?.keywords?.toFixed(
                      2
                    )}
                    %
                  </li>
                  <li
                    className={`${calculateBrandedColor(
                      analysis?.linking?.anchor_text_type_ratios?.branded,
                      analysis?.linking?.anchor_text_type_ratios?.keywords
                    )}`}
                  >
                    {t("Branded", "Branded")} :{" "}
                    {analysis?.linking?.anchor_text_type_ratios?.branded?.toFixed(
                      2
                    )}
                    %
                  </li>
                  <li
                    className={`${
                      analysis?.linking?.anchor_text_type_ratios?.other > 15
                        ? "text-red-600"
                        : "text-green-500"
                    }`}
                  >
                    {t("Others", "Others")}:{" "}
                    {analysis?.linking?.anchor_text_type_ratios?.other?.toFixed(
                      2
                    )}
                    %
                  </li>
                  <li
                    className={`${
                      analysis?.linking?.anchor_text_type_ratios?.empty > 0
                        ? "text-red-600"
                        : "text-green-500"
                    }`}
                  >
                    {t("Empty", "Empty")} :{" "}
                    {analysis?.linking?.anchor_text_type_ratios?.empty?.toFixed(
                      2
                    )}
                    %
                  </li>
                </ul>
              )}
            </span>
          </div>

          {/* Anchor Length Score */}
          <div className="text-xs text-black  ">
            <span>
              {" "}
              {t("Anchor_length_score", "Anchor length score")}?
              <span
                className={`${
                  analysis?.linking?.anchor_length_score >= 75 &&
                  (analysis?.linking?.nb_internal_links > 0 ||
                    analysis?.linking?.nb_external_links > 0)
                    ? "text-green-500"
                    : analysis?.linking?.anchor_length_score >= 35 &&
                      analysis?.linking?.anchor_length_score < 75 &&
                      (analysis?.linking?.nb_internal_links > 0 ||
                        analysis?.linking?.nb_external_links > 0)
                    ? "text-yellow-500"
                    : analysis?.linking?.nb_internal_links > 0 ||
                      analysis?.linking?.nb_external_links > 0
                    ? "text-red-600"
                    : "text-gray_local-400"
                }`}
              >
                {" "}
                {analysis?.linking?.nb_internal_links > 0 ||
                analysis?.linking?.nb_external_links > 0
                  ? analysis?.linking?.anchor_length_score
                  : t("No_link_found", "No link found")}
              </span>
            </span>
          </div>
          {/* Button for link table */}
          <div className="text-center flex justify-center mt-4">
            {competitorResults?.pageLinks?.id === index ? (
              <button
                onClick={handleHidePageLinkTable}
                className="text-xs hover:bg-blue-200 *: bg-blue-100 text-white font-light px-5 py-[6px] rounded flex items-center "
              >
                {t("hide-link-table", "Hide link table")}
              </button>
            ) : (
              <LoadingButton
                variant="contained"
                onClick={handleLinkingTableByPageId}
                loading={loadingPageLinkTable}
                size={"small"}
                className="!text-xs disabled:!text-transparent disabled:!bg-slate-200 !normal-case hover:!bg-blue-100 *: bg-blue-200 !text-white !font-light px-5 py-[6px] !rounded flex items-center "
              >
                {t("view-link-table", "View link table")}
              </LoadingButton>
            )}
          </div>
        </div>
      </div>
    </>
  ) : null;
}
